var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank19 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 103,
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_401)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_401)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM64.4704 37.132C64.7984 35.492 65.1264 34.016 65.6184 32.622C66.0284 31.228 66.6024 29.998 67.2584 28.932C67.9144 27.948 68.6524 27.128 69.6364 26.554C70.6204 25.98 71.7684 25.652 73.2444 25.652C75.0484 25.652 76.3604 26.144 77.0164 27.128C77.6724 28.112 78.0824 29.506 78.0824 31.146C78.0824 32.95 77.8364 35 77.3444 37.132C76.5244 41.068 75.3764 43.938 74.0644 45.578C72.7524 47.3 70.8664 48.12 68.5704 48.12C66.9304 48.12 65.7004 47.71 64.8804 46.89C64.0604 46.07 63.7324 44.676 63.7324 42.708C63.7324 41.232 63.9784 39.428 64.4704 37.132ZM60.1244 62.47H48.8084C48.6444 63.208 48.4804 63.864 48.4804 64.52C48.3984 65.176 48.3984 65.75 48.3984 66.324C48.3984 68.374 48.7264 70.096 49.4644 71.49C50.2024 72.884 51.1864 74.032 52.4164 74.852C53.6464 75.672 55.1224 76.328 56.7624 76.656C58.4024 76.984 60.1244 77.148 61.9284 77.148C66.6844 77.148 70.6204 76.246 73.5724 74.442C76.5244 72.638 78.9844 70.26 80.8704 67.308C82.6744 64.356 84.1504 60.912 85.2164 57.058C86.2004 53.204 87.1844 49.186 88.0864 45.086C88.4964 42.79 88.9064 40.576 89.2344 38.444C89.5624 36.312 89.7264 34.262 89.7264 32.294C89.7264 30.244 89.4804 28.358 89.0704 26.554C88.5784 24.832 87.8404 23.356 86.7744 22.044C85.6264 20.732 84.1504 19.748 82.3464 19.01C80.5424 18.354 78.2464 17.944 75.4584 17.944C68.8984 17.944 63.7324 19.748 60.0424 23.274C56.2704 26.882 53.7284 31.966 52.3344 38.69C51.8424 41.15 51.5964 43.282 51.5964 45.25C51.5964 48.776 52.4164 51.564 54.1384 53.696C55.8604 55.828 58.7304 56.812 62.7484 56.812C65.3724 56.812 67.6684 56.402 69.7184 55.5C71.6864 54.598 73.4084 53.368 74.7204 51.892H74.8844L74.3104 54.68C73.8184 56.812 73.3264 58.78 72.8344 60.584C72.2604 62.388 71.6044 63.946 70.7844 65.258C69.9644 66.57 69.0624 67.636 67.9144 68.374C66.7664 69.112 65.4544 69.44 63.9784 69.44C62.4204 69.44 61.3544 69.112 60.6984 68.374C60.0424 67.718 59.7964 66.652 59.7964 65.258C59.7964 64.356 59.8784 63.454 60.1244 62.47Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_401",
  x: -11,
  y: 0.94397,
  width: 120.726,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_401"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_401",
  result: "effect2_dropShadow_1_401"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_401",
  result: "effect3_dropShadow_1_401"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_401",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_401",
  x: 16.808,
  y: 17.944,
  width: 76.9185,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_401"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_401",
  result: "shape"
})))));
export default SvgRank19;